import { FormType } from '../../../form-types';
import { BummedQuestionAnswerFields } from '../questions';

const bummedDataPolicy: FormType<BummedQuestionAnswerFields> = {
  name: 'Bummed Data Policy',

  questions: ['bummed_dataPolicy']
};
export default bummedDataPolicy;
